import React, { useContext, useState } from 'react';

import TemplatesWizardContext from '../../../TemplatesWizardContext';

import { TEMPLATES_WIZARD_STEP_KEYS } from '../../../../../helpers/constants';

import arrow from '../../../../../../../../../assets/img/templateswizard/arrow.svg';
import linkIcon from '../../../../../../../../../assets/img/link.svg';
import questionIcon from '../../../../../../../../../assets/img/question.svg';

import styles from './SetUseberryLink.module.css';

export default function SetUseberryLink() {
  const {
    currentStep,
    setStepValue,
    goToNextStep,
    goToPreviousStep,
    strings
  } = useContext(TemplatesWizardContext);

  const [nameTooltip, setNameTooltip] = useState(null);

  const isDisabledNext = () => {
    const link = (currentStep.value || '').trim();
    if (!link.length) return true;

    try {
      const url = new URL(link);
      return url.protocol !== 'http:' && url.protocol !== 'https:';
    } catch (error) {
      return true;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {strings.ADD_YOUR_USEBERRY_UX_STUDY_LINK}
      </div>
      <div className={styles.subTitle}>
        {strings.PASTE_THE_URL_OF_YOUR_UX_STUDY}
      </div>
      <div className={styles.inputSection}>
        <div className={styles.inputLabel}>
          {strings.USEBERRY_UX_STUDY_LINK}
          <span
            style={{ display: 'inline-block', position: 'relative' }}
            onMouseEnter={() => setNameTooltip(true)}
            onMouseLeave={() => {
              if (nameTooltip) {
                setNameTooltip(false);
              }
            }}
          >
            <img
              className={styles.helpIcon}
              src={questionIcon}
              alt="Help icon"
              title={strings.USEBERRY_UX_STUDY_LINK_TOOLTIP}
            />
            <div
              className={styles.tooltip}
              style={nameTooltip ? { display: 'block' } : {}}
            >
              {strings.USEBERRY_UX_STUDY_LINK_TOOLTIP}
            </div>
          </span>
        </div>
        <div className={styles.inputWrapper}>
          <img className={styles.linkIcon} src={linkIcon} alt="Link icon" />
          <input
            type="text"
            placeholder="https://www.app.useberry.com/..."
            aria-label={strings.USEBERRY_UX_STUDY_LINK}
            value={currentStep.value || ''}
            onChange={e =>
              setStepValue(
                TEMPLATES_WIZARD_STEP_KEYS.SET_USEBERRY_LINK,
                e.target.value
              )
            }
            onKeyDown={e => {
              if (e.key === 'Enter' && !isDisabledNext()) goToNextStep();
            }}
          />
        </div>
      </div>
      <div className={styles.footerContainer}>
        <div
          className={styles.previousButton}
          onClick={goToPreviousStep}
          role="presentation"
        >
          <img src={arrow} alt="Left arrow" />
          {strings.PREVIOUS}
        </div>
        <div
          className={
            isDisabledNext()
              ? `${styles.nextButton} ${
                  styles.disabled
                } builder-wizard-template-next-button`
              : `${styles.nextButton} builder-wizard-template-next-button`
          }
          onClick={() => {
            if (!isDisabledNext()) goToNextStep();
          }}
          role="presentation"
        >
          {strings.NEXT}
          <img src={arrow} alt="Right arrow" />
        </div>
      </div>
    </div>
  );
}
